import React from 'react';
import Seo from '@/components/Seo';
import {
    ResumeHero,
    ResumeExperience,
    ResumeSkills,
    ResumeProjects,
    ResumeContact,
} from '@/components/resume';

/**
 * Proof-of-concept "résumé/portfolio" product variant (§11 of
 * `docs/TEMPLATE_IMPROVEMENT_RECOMMENDATIONS.md`): demonstrates that the same
 * content-layer + section-toggle architecture used to render the business
 * one-pager (`src/pages/Home.tsx` + `siteConfig.sections`) can ship an
 * entirely different product — Hero → Experience → Skills → Projects →
 * Contact — by swapping the content module (`src/content/resume.ts`) and the
 * section registry below, without touching a single shared primitive
 * (`Section`, `Card`, `Reveal`, `Button`, ...).
 *
 * This is a **reference implementation**, not part of the default nav
 * (it isn't listed in `siteConfig.pages`) — reachable at `/resume-demo` for
 * buyers evaluating the résumé/portfolio variant. Delete this file, its
 * route in `App.tsx`, `src/components/resume/`, and `src/content/resume.ts`
 * for a pure business-template build.
 */
const RESUME_SECTIONS = [
    ResumeHero,
    ResumeExperience,
    ResumeSkills,
    ResumeProjects,
    ResumeContact,
] as const;

const ResumeDemo: React.FC = () => {
    return (
        <>
            <Seo title="Résumé / Portfolio Variant" path="/resume-demo" noindex />
            {RESUME_SECTIONS.map((Component, index) => (
                <Component key={index} />
            ))}
        </>
    );
};

export default ResumeDemo;
